export default __webpack_public_path__ + "static/media/img60.99e4e98c.jpg";